import { Typography } from '@automata/ui';
import ListItem from '@mui/material/ListItem';

type Props = {
  title: string;
  description: string;
  lastItem?: boolean;
};

const BulletPoint = ({ title, description, lastItem }: Props): JSX.Element => {
  const paddingBottom = lastItem ? 0 : undefined;
  return (
    <ListItem sx={{ display: 'list-item', pb: paddingBottom, pl: 1, ml: 2 }}>
      <Typography variant="subtitle2" component="p">
        {title}
      </Typography>
      <Typography variant="body2">{description}</Typography>
    </ListItem>
  );
};

export default BulletPoint;
